export const ModeratorNotificationIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z"
      fill="#FF6200"
    />
    <path
      d="M15 10.5992C15 13.5987 12.8125 15.0984 10.2125 15.9683C10.0764 16.0125 9.92846 16.0104 9.79375 15.9623C7.1875 15.0984 5 13.5987 5 10.5992V6.39987C5 6.24076 5.06585 6.08818 5.18306 5.97567C5.30027 5.86317 5.45924 5.79997 5.625 5.79997C6.875 5.79997 8.4375 5.08009 9.525 4.16824C9.65741 4.05966 9.82585 4 10 4C10.1742 4 10.3426 4.05966 10.475 4.16824C11.5688 5.08609 13.125 5.79997 14.375 5.79997C14.5408 5.79997 14.6997 5.86317 14.8169 5.97567C14.9342 6.08818 15 6.24076 15 6.39987V10.5992Z"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
